module.exports = __webpack_public_path__ + "img/mb_bg_old.4f5697b.webp";